import Heading from './heading/Heading'
import Informative from './informative/Informative'
import Label from './label/Label'
import Link from './link/Link'
import LinkPhoneNumber from './link-phone-number/LinkPhoneNumber'
import ListItem from './list-item/ListItem'
import Paragraph from './paragraph/Paragraph'

export {
  Heading,
  Informative,
  Label,
  Link,
  LinkPhoneNumber,
  ListItem,
  Paragraph,
}
